import { useState, useEffect } from "react";
import { getAllByDokumentId } from "../../services/statistikaDokumenta.service";
import dokumentService from "../../services/dokument.service";
import "./TopDesetDokumenata.css";

const TopDokumenti = () => {
  const [topDokumenti, setTopDokumenti] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTopDokumenti = async () => {
      setLoading(true);
      try {
      
        const { data: dokumenti } = await dokumentService.getAll();
        const dokumentiSaPosjetama = await Promise.all(
          dokumenti.map(async (dokument) => {
            try {
              const { data } = await getAllByDokumentId(dokument.id);
              const brojPosjeta = Array.isArray(data) ? data.length : 0;

              return { ...dokument, broj_posjeta: brojPosjeta };
            } catch (error) {
              return { ...dokument, broj_posjeta: 0 };
            }
          })
        );
        const top10 = dokumentiSaPosjetama
          .sort((a, b) => b.broj_posjeta - a.broj_posjeta)
          .slice(0, 10);
        setTopDokumenti(top10);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchTopDokumenti();
  }, []);

  return (
    <div className="topdeset-dokumenta-div">
      <h3 className="topdeset-dokumenta-h3">
        Top 10 najposjećenijih dokumenata
      </h3>
      {loading ? (
        <p>🔄 Učitavanje...</p>
      ) : (
        <ol className="topdeset-dokumenta-ol">
          {topDokumenti.map((dokument, index) => (
            <li key={dokument.id}>
              <strong className="topdeset-dokumenta-strong">
                {dokument.naziv}
              </strong>
              - broj posjeta: {dokument.broj_posjeta}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default TopDokumenti;
